module.exports = __webpack_public_path__ + "static/media/logoNname.9dfebea2.svg";